<bit-dialog dialogSize="default" background="default" class="bv-import-success-dialog">
  <span bitDialogTitle>{{ "importSuccess" | i18n }}</span>

  <div bitDialogContent>
    <p class="bv-import-success-dialog__summary">
      {{ "importSuccessNumberOfItems" | i18n: totalImported }}
    </p>
    <div class="bv-import-success-dialog__table">
      <div class="bv-import-success-dialog__table-header">
        <span>{{ "type" | i18n }}</span>
        <span>{{ "total" | i18n }}</span>
      </div>
      @for (row of dataSource.data; track row.type) {
        <div class="bv-import-success-dialog__table-row">
          <span class="bv-import-success-dialog__type">
            <i class="bwi bwi-fw bwi-{{ row.icon }}" aria-hidden="true"></i>
            {{ row.type | i18n }}
          </span>
          <span class="bv-import-success-dialog__count">{{ row.count }}</span>
        </div>
      }
    </div>
  </div>

  <ng-container bitDialogFooter>
    <div class="bv-import-dialog__footer bv-import-dialog__footer--end">
      @if (hasReturnDestination) {
        <button
          data-testid="return-button"
          bitButton
          buttonType="primary"
          type="button"
          endIcon="bwi-arrow-right"
          (click)="navigateBack()"
        >
          {{ data.returnLabel }}
        </button>
      } @else {
        <button data-testid="ok-button" bitButton bitDialogClose buttonType="primary" type="button">
          {{ "ok" | i18n }}
        </button>
      }
    </div>
  </ng-container>
</bit-dialog>
